import type { ShiptimeShipmentResponse } from '@shipium-corp/shipium-ts-types';
import type { ColumnsType } from 'antd/es/table';
import { convertMatrixToCsvString, downloadCsvFile } from '../files/fileUtils';
import type { CarrierSelection } from '../services/ShiptimeService/types';
import type { CancelShipmentPayload } from '.';
import { PRINT_LABEL_TAG_PREFIX, PACK_APP_PRINT_LABEL_TAG_PREFIX } from '.';
import type { MultiParcelShipment } from '../../components/carrier/CarrierRateCalculationPanel';

export const adaptV2CarrierSelectionResponseToV1 = (carrierSelectionResponse: CarrierSelection) => {
  // handles deprecared cases where serviceMethodUrn is not set
  if (
    !carrierSelectionResponse.carrierDecision.serviceMethodUrn &&
    carrierSelectionResponse.carrierDecision.serviceMethodIdentifier
  ) {
    carrierSelectionResponse.carrierDecision.serviceMethodUrn =
      carrierSelectionResponse.carrierDecision.serviceMethodIdentifier;
  }
  if (Array.isArray(carrierSelectionResponse?.carrierDecision?.details?.availableServiceMethods)) {
    carrierSelectionResponse.carrierDecision.details!.availableServiceMethods.map(
      (method) => (method.serviceMethodUrn = method.serviceMethodIdentifier || method.serviceMethodUrn),
    );
  }
  if (Array.isArray(carrierSelectionResponse?.carrierDecision?.details?.calculatedRates)) {
    carrierSelectionResponse.carrierDecision.details!.calculatedRates.map(
      (method) => (method.serviceMethodUrn = method.serviceMethodIdentifier || method.serviceMethodUrn),
    );
  }
  return carrierSelectionResponse;
};

export const exportTableData = async (columns: ColumnsType<any>, records: any[], fileName: string) => {
  const rows = records.map((record, index) => {
    return columns
      .map((col) => {
        return col.key?.toString();
      })
      .filter((col) => !!col)
      .map((col) => {
        if (col === 'percentage') {
          return record[col].toString() + '%';
        }
        return col ? record[col] : '';
      });
  });
  const ws = await convertMatrixToCsvString([columns.map((val: any) => val.title), ...rows]);
  downloadCsvFile(ws, fileName);
};

export const exportData = async (records: any[], fileName: string) => {
  const rows = [];
  for (const record of records) {
    for (const [carrier, value] of Object.entries(record)) {
      if (!['epoch', 'timestamp', 'total'].includes(carrier)) {
        rows.push([record.timestamp, carrier, value]);
      }
    }
  }
  const ws = await convertMatrixToCsvString([['Date', 'Carrier', 'Value'], ...rows]);
  downloadCsvFile(ws, fileName);
};

// cancel endpoint expects 1 and only one id to be passed
// pass the most destructive id available from payload
export const shapeCancelHierarchy = (payload: CancelShipmentPayload) => {
  const { shipiumShipmentId, carrierSelectionId, shipiumLabelId } = payload;
  if (shipiumShipmentId) {
    return { shipmentId: shipiumShipmentId };
  }
  if (carrierSelectionId) {
    return { carrierSelectionId };
  }
  return { shipiumLabelId };
};

export const shipmentWasGeneratedThroughPrintLabels = (payload?: ShiptimeShipmentResponse | MultiParcelShipment) => {
  if (!payload?.details?.megaMethodRequestParams?.shipmentParameters?.shipmentTags) {
    return false;
  }
  return !!payload.details.megaMethodRequestParams.shipmentParameters.shipmentTags.find((tag: string) =>
    tag.includes(PRINT_LABEL_TAG_PREFIX),
  );
};

export const shipmentWasGeneratedThroughPackAppPrintLabels = (
  payload?: ShiptimeShipmentResponse | MultiParcelShipment,
) => {
  if (!payload?.details?.megaMethodRequestParams?.shipmentParameters?.shipmentTags) {
    return false;
  }
  return !!payload.details.megaMethodRequestParams.shipmentParameters.shipmentTags.find((tag: string) =>
    tag.includes(PACK_APP_PRINT_LABEL_TAG_PREFIX),
  );
};
